/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./style.css";
import hamed from "../../assests/images/hamed-hasan.png";
import TypeWriter from "../TypeWriter/TypeWriter";
import { FiDownload } from "react-icons/fi";
import ReactHelmet from "../ReactHelmet/ReactHelmet";
import Social from "../../shared/Socials/Social";
import CallToAction from "../../shared/CallToAction/CallToAction";
import "./Home.scss";
import "./style.css";
const Home = () => {
  return (
    <div class="hero min-h-screen bg-accent">
    <div className="container">
    <ReactHelmet title="Home" />
      <div className="color bg-primary hidden lg:block"></div>

      <div class="hero-content flex-col lg:flex-row">
        <img
          src={hamed}
          class="rounded-full w-52 lg:hidden lg:w-full border-slate-900 border-8 lg:border-0 lg:rounded-3xl shadow-2xl"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        />

        <div className="c-glitch rounded-full w-52 hidden lg:block  lg:w-full border-slate-900 border-8 lg:border-0 lg:rounded-3xl shadow-2xl">
          <div
            className="c-glitch__img"
            style={{ backgroundImage: `url(${hamed})` }}
          ></div>
          <div
            className="c-glitch__img"
            style={{ backgroundImage: `url(${hamed})` }}
          ></div>
          <div
            className="c-glitch__img"
            style={{ backgroundImage: `url(${hamed})` }}
          ></div>
          <div
            className="c-glitch__img"
            style={{ backgroundImage: `url(${hamed})` }}
          ></div>
          <div
            className="c-glitch__img"
            style={{ backgroundImage: `url(${hamed})` }}
          ></div>
          <div
            className="c-glitch__img"
            style={{ backgroundImage: `url(${hamed})` }}
          ></div>
        </div>

        <div className="lg:px-20">
          <div className="flex items-center">
            <span className="text-8xl text-primary">-</span>
            <TypeWriter />
          </div>

          <p class="text-secondary opacity-80 pb-10 mb-28 md:mb-0 text-left text-lg">
            Experienced Full-Stack Developer and data Scientist | Crafting
            Innovative Solutions with Precision and impact | Mastery in
            End-to-End Development and advanced Analytics | Building Robust
            Software for Complex Challenges | Dedicated to Catalyzing Business
            Growth Through Technology | Explore My Portfolio for Transformative
            Projects and remarkable Achievements.
          </p>

          <a
            className="button border-2  border-primary hover:before:bg-primary hover:text-pureWhite mb-16 lg:md-0"
            href="https://drive.google.com/file/d/1tSTMg-gENjVq0aBLvXYrVvGLhmuG778c/view?usp=sharing"
            download="Hamed_Hasan_Full Stack Developer_Resume.pdf"
            target="_blank"
            data-aos="zoom-in"
            data-aos-duration="1000"
            rel="noreferrer"
          >
            <span className="text-neutral">Download Resume</span>
            <span className="button-icon bg-primary">
              <FiDownload />
            </span>
          </a>

          <Social />
          <CallToAction />
        </div>
      </div>
    </div>
    </div>
  );
};

export default Home;
